import React, { useEffect, useState } from "react";
import "./PricingPage.css";
import {
  getPricing,
  savePricing,
  updatePricing,
} from "../../../services/payment/api";
import { useLocation, useParams } from "react-router-dom";
import { FaSave, FaUndo } from "react-icons/fa";
import { toast } from "react-toastify";

const defaultPricing = [
  {
    checkId: 1,
    checkName: "Digilocker Check",
    price: "",
  },
  {
    checkId: 2,
    checkName: "Criminal Check",
    price: "",
  },
  {
    checkId: 3,
    checkName: "UAN Check",
    price: "",
  },
  {
    checkId: 4,
    checkName: "Employment Check",
    price: "",
  },
];

const PricingPage = () => {
  const { clientId } = useParams();
  const location = useLocation();
  const client = location.state?.client;

  const [errors, setErrors] = useState({});
  const [pricingItems, setPricingItems] = useState(defaultPricing);
  const [pricingList, setPricingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    if (clientId) {
      loadPricing();
    }
  }, [clientId]);

  const loadPricing = async () => {
    try {
      setLoading(true);

      const response = await getPricing(clientId);

      console.log("Pricing Response", response);

      if (response && response.length > 0) {
        setPricingList(response);

        const updated = defaultPricing.map((check) => {
          const saved = response.find(
            (item) => item.checkId === check.checkId
          );

          return {
            ...check,
            price: saved ? saved.price : "",
          };
        });

        setPricingItems(updated);
        setEditMode(true);
      } else {
        setPricingItems(defaultPricing);
        setPricingList([]);
        setEditMode(false);
      }
    } catch (err) {
      console.error("Error loading pricing:", err);

      setPricingItems(defaultPricing);
      setPricingList([]);
      setEditMode(false);
    } finally {
      setLoading(false);
    }
  };

  const validatePricing = () => {
    const validationErrors = {};

    pricingItems.forEach((item) => {
      if (item.price === "" || item.price === null) {
        validationErrors[item.checkId] =
          `${item.checkName} price is required`;
        return;
      }

      const price = Number(item.price);

      switch (item.checkId) {
        case 1:
          if (price < 50) {
            validationErrors[item.checkId] =
              "Minimum price for Digilocker Check is ₹50";
          }
          break;

        case 2:
          if (price < 100) {
            validationErrors[item.checkId] =
              "Minimum price for Criminal Check is ₹100";
          }
          break;

        case 3:
          if (price < 200) {
            validationErrors[item.checkId] =
              "Minimum price for UAN Check is ₹200";
          }
          break;

        case 4:
          if (price < 200) {
            validationErrors[item.checkId] =
              "Minimum price for Employment Check is ₹200";
          }
          break;

        default:
          break;
      }
    });

    setErrors(validationErrors);

    return Object.keys(validationErrors).length === 0;
  };

  const handlePrice = (index, value) => {
    const temp = [...pricingItems];

    temp[index].price = value;

    setPricingItems(temp);

    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[temp[index].checkId];
      return newErrors;
    });
  };

  const resetForm = () => {
    if (pricingList.length > 0) {
      const updated = defaultPricing.map((check) => {
        const saved = pricingList.find(
          (item) => item.checkId === check.checkId
        );

        return {
          ...check,
          price: saved ? saved.price : "",
        };
      });

      setPricingItems(updated);
    } else {
      setPricingItems(defaultPricing);
    }

    setErrors({});
  };

  const handleSave = async () => {
    if (!validatePricing()) {
      return;
    }

    const request = {
      pricingItems: pricingItems.map((item) => ({
        checkId: item.checkId,
        price: Number(item.price),
      })),
    };

    try {
      if (editMode) {
        await updatePricing(clientId, request);
        toast.success("Pricing Updated Successfully");
      } else {
        await savePricing(clientId, request);
        toast.success("Pricing Saved Successfully");
      }

      loadPricing();
      setErrors({});
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Something went wrong"
      );
    }
  };
    return (
    <div className="pricing-wrapper">
      <div className="pricing-header">
        <h2>Client Pricing</h2>
      </div>

      {/* Client Details */}
      <div className="pricing-client-card">
        <div className="pricing-client-info">
          <div className="pricing-client-item">
            <label>Client Name</label>
            <span>{client?.username || "-"}</span>
          </div>

          <div className="pricing-client-item">
            <label>Company Name</label>
            <span>{client?.companyName || "-"}</span>
          </div>

          <div className="pricing-client-item">
            <label>Client User ID</label>
            <span>{client?.email || "-"}</span>
          </div>
        </div>
      </div>

      {/* Pricing Form */}
      <div className="pricing-form-card">
        <h3 className="pricing-form-title">Add / Update Pricing</h3>

        {pricingItems.map((item, index) => (
          <div key={item.checkId} className="pricing-row">

            {/* Check Name */}
            <div className="pricing-left">
              <label>{item.checkName}</label>
            </div>

            {/* Price Input */}
            <div className="price-field">
              <div
                className={`price-box ${
                  errors[item.checkId] ? "price-box-error" : ""
                }`}
              >
                <span className="price-symbol">₹</span>

                <input
                  type="number"
                  min="0"
                  className="pricing-input"
                  placeholder="Enter Price"
                  value={item.price}
                  onChange={(e) =>
                    handlePrice(index, e.target.value)
                  }
                />
              </div>

              {errors[item.checkId] && (
                <div className="pricing-error">
                  {errors[item.checkId]}
                </div>
              )}
            </div>
          </div>
        ))}

        <div className="pricing-button-group">
          <button
            className="pricing-reset-btn"
            onClick={resetForm}
          >
            <FaUndo />
            &nbsp;Reset
          </button>

          <button
            className="pricing-save-btn"
            onClick={handleSave}
          >
            <FaSave />
            &nbsp;
            {editMode ? "Update Pricing" : "Save Pricing"}
          </button>
        </div>
      </div>

      {/* Current Pricing List */}
      <div className="pricing-table-card">
        <h3 className="pricing-table-title">
          Current Pricing List
        </h3>

        <div className="pricing-table-container">
          <table className="pricing-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Check Name</th>
                <th>Credits</th>
                <th>Updated On</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan="4"
                    className="pricing-loading"
                  >
                    Loading...
                  </td>
                </tr>
              ) : pricingList.length === 0 ? (
                <tr>
                  <td
                    colSpan="4"
                    className="pricing-empty"
                  >
                    No Pricing Configured
                  </td>
                </tr>
              ) : (
                pricingList.map((item, index) => (
                  <tr key={item.checkId}>
                    <td>{index + 1}</td>
                    <td>{item.checkName}</td>
                    <td>₹ {item.price}</td>
                    <td>
                      {item.updatedAt
                        ? new Date(
                            item.updatedAt
                          ).toLocaleDateString()
                        : "-"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;